import React, { useEffect } from 'react';

import { useDelayUnmount } from '../../hooks/useDelayUnmount';
import { ModalContainer, ModalBackground } from './Modal.style';
import { TModalProps } from './Modal.types';
import { ModalCloseButton } from './components/ModalCloseButton/ModalCloseButton';

export const Modal = ({
  isOpen,
  children,
  toggleModal,
  largerTopMargin,
  compactModal,
}: TModalProps) => {
  const isModalShown = useDelayUnmount(isOpen);

  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'visible';
  }, [isOpen]);

  return (
    isModalShown && (
      <ModalBackground isOpen={isOpen} onClick={() => toggleModal()} className="modal-background">
        <ModalContainer
          onClick={(event) => event.stopPropagation()}
          largerTopMargin={largerTopMargin}
          compactModal={compactModal}
          className="modal-container"
        >
          <ModalCloseButton onClick={() => toggleModal()} />
          <div className="modal-container-content">{children}</div>
        </ModalContainer>
      </ModalBackground>
    )
  );
};
